import { trace } from 'owa-trace';
import { hasQueryStringParameter } from 'owa-querystring';
import { createAppContext } from 'mini-app-context';

const measureData = {};

let isLogMeasureEnabledInQueryString = null;
const isMeasureLoggingInConsoleEnabled = () => {
    if (isLogMeasureEnabledInQueryString === null) {
        isLogMeasureEnabledInQueryString = hasQueryStringParameter('logmeasureinconsole');
    }
    return isLogMeasureEnabledInQueryString;
};

/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export function measurePerf(measureName: string, customPayload?: any) {
    if (!measureData[measureName]) {
        measureData[measureName] = {
            totalDuration: 0,
            totalOperations: 0,
            timer: null,
        };
    }

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    return (func: any) => {
        const startDuration = performance.now();
        const result = func();
        const endDuration = performance.now();
        const duration = endDuration - startDuration;

        measureData[measureName].totalDuration = measureData[measureName].totalDuration + duration;
        measureData[measureName].totalOperations = measureData[measureName].totalOperations + 1;

        clearTimeout(measureData[measureName].timer);
        measureData[measureName].timer = setTimeout(() => {
            const payloadToSend = {
                totalDuration: measureData[measureName].totalDuration,
                totalOperations: measureData[measureName].totalOperations,
                ...customPayload,
            };
            createAppContext().signal(measureName, payloadToSend);
            isMeasureLoggingInConsoleEnabled() &&
                trace.info(measureName + ': ' + JSON.stringify(payloadToSend));
            delete measureData[measureName];
        }, 1000);

        return result;
    };
}
